import { Loader } from "@pushpress/shared-components";
import { SignUpStep } from "../../constants/signup-step.enum";
import AccountConfirmationStep from "../steps/AccountConfirmationStep";
import BusinessNeedsStep from "../steps/BusinessNeedsStep";
import CompanyStep from "../steps/CompanyStep";
import ContactInfoStep from "../steps/ContactInfoStep";
import CountryStep from "../steps/CountryStep";
import CreatePasswordStep from "../steps/CreatePasswordStep";
import CurrentSoftwareStep from "../steps/CurrentSoftwareStep";
import EmailStep from "../steps/EmailStep";
import FreeStep from "../steps/FreeStep";
import RevenueStep from "../steps/RevenueStep";
import UnsupportedStep from "../steps/UnsupportedStep";
import VerticalStep from "../steps/VerticalStep";
import YearsOpenStep from "../steps/YearsOpenStep";
import BusinessNameStep from "../steps/BusinessNameStep";
import ContactInfoAltStep from "../steps/ContactInfoAltStep";
import ImplicitCreateFreeAccountStep from "../steps/ImplicitCreateFreeAccountStep";

export interface StepRendererProps {
  currentState: string;
  variant: "control" | "variant";
}

export const StepRenderer: React.FC<StepRendererProps> = ({
  variant,
  currentState,
}: {
  variant: "control" | "variant";
  currentState: string;
}) => {
  switch (currentState) {
    case SignUpStep.Email:
      return <EmailStep />;
    case SignUpStep.Company:
      return variant === "control" ? <CompanyStep /> : <BusinessNameStep />;
    case SignUpStep.Country:
      return <CountryStep />;
    case SignUpStep.YearsOpen:
      return <YearsOpenStep />;
    case SignUpStep.Revenue:
      return <RevenueStep />;
    case SignUpStep.Vertical:
      return <VerticalStep />;
    case SignUpStep.BusinessNeeds:
      return <BusinessNeedsStep />;
    case SignUpStep.CurrentSoftware:
      return <CurrentSoftwareStep />;
    case SignUpStep.ContactInfo:
      return variant === "control" ? (
        <ContactInfoStep />
      ) : (
        <ContactInfoAltStep />
      );
    case SignUpStep.Free:
      return variant === "control" ? (
        <FreeStep />
      ) : (
        <ImplicitCreateFreeAccountStep />
      );
    case SignUpStep.AccountConfirmation:
      return <AccountConfirmationStep />;
    case SignUpStep.CreatePassword:
      return <CreatePasswordStep />;
    case SignUpStep.Unsupported:
      return <UnsupportedStep />;
    case SignUpStep.Final:
    default:
      console.warn("Unhandled signup state:", currentState);
      return <Loader />;
  }
};
